export const PAGE_LOADER_CONSTANTS = {
  LOADING: true,
  NOT_LOADING: false,
  OVERLAY_TYPE: "undefined",
};
